import { GraphQLClient } from "graphql-request";
// import { API_HOST } from "./config"

const url = process.env.REACT_APP_API_HOST + "/graphql";
const options = {
  method: "post"
};
export default new GraphQLClient(url, options);



// WEBPACK FOOTER //
// ./src/Client.js